import _classCallCheck from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Extensions
import { Service } from '../service';
export var Application = /*#__PURE__*/function (_Service) {
  _inherits(Application, _Service);
  var _super = _createSuper(Application);
  function Application() {
    var _this;
    _classCallCheck(this, Application);
    _this = _super.apply(this, arguments);
    _this.bar = 0;
    _this.top = 0;
    _this.left = 0;
    _this.insetFooter = 0;
    _this.right = 0;
    _this.bottom = 0;
    _this.footer = 0;
    _this.application = {
      bar: {},
      top: {},
      left: {},
      insetFooter: {},
      right: {},
      bottom: {},
      footer: {}
    };
    return _this;
  }
  _createClass(Application, [{
    key: "register",
    value: function register(uid, location, size) {
      this.application[location][uid] = size;
      this.update(location);
    }
  }, {
    key: "unregister",
    value: function unregister(uid, location) {
      if (this.application[location][uid] == null) return;
      delete this.application[location][uid];
      this.update(location);
    }
  }, {
    key: "update",
    value: function update(location) {
      this[location] = Object.values(this.application[location]).reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    }
  }]);
  return Application;
}(Service);
Application.property = 'application';